import { Modal } from "react-rainbow-components";
import styled from "styled-components";


export const Container = styled.div`
display: flex;
flex-direction: column;
overflow: hidden;
`;
export const ContainerHeader = styled.div`
display: flex;
flex-direction: column;
padding: 0.5rem 1rem;
`;
export const UserCountaints = styled.div`
display: flex;
flex-direction: column;
flex: 1;
overflow-y: scroll;
`;
export const MyModal = styled(Modal)`
overflow: hidden;
> section > div > div {
  overflow-y: visible;
}
`;

export const CardUser = styled.div`
display: flex;
background-color: #fff;
padding: 0.5rem 1rem;
margin-bottom: 0.5rem;
border-radius: 8px;
justify-content: space-between;
`;
export const TextSelect = styled.span`
transition: all 0.5s ease;
font-size: 1rem;
margin-left: 0.25rem;
color: #fff;
display: none;
`;
export const SelectButton = styled.span`
background-color: #123559;
cursor: pointer;
width: 1.5rem;
height: 1.5rem;
border-radius: 999rem;
color: #fff;
transition: all 0.5s ease;
font-size: 1.5rem;
display: flex;
justify-content: center;
align-items: center;
&:hover {
  transition: all 0.5s ease;
  width: 3.5rem;
}
&:hover ${TextSelect} {
  transition: all 0.5s ease;
  display: block;
}
`;